import React from 'react';
import { History, Calendar } from 'lucide-react';
import { Calculation, formatNumber, UNITS } from '../utils/calculationUtils';

interface CalculationHistoryProps {
  calculations: Calculation[];
}

export const CalculationHistory: React.FC<CalculationHistoryProps> = ({ calculations }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <div className="flex items-center mb-6">
        <History className="h-6 w-6 text-blue-600 mr-2" />
        <h3 className="text-xl font-semibold text-slate-800">Recent Calculations</h3>
      </div>
      
      <div className="space-y-4">
        {calculations.map((calc) => (
          <div 
            key={calc.id}
            className="border border-slate-200 rounded-lg p-4 hover:border-blue-300 transition-colors duration-300"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center text-slate-600">
                <Calendar className="h-4 w-4 mr-2" />
                <span className="text-sm">
                  {new Date(calc.timestamp).toLocaleString()}
                </span>
              </div>
              <span className="text-sm font-medium text-slate-600">
                {calc.unit === UNITS.IMPERIAL ? 'Imperial' : 'Metric'}
              </span>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <p className="text-sm text-slate-600">Width</p>
                <p className="font-medium">
                  {formatNumber(calc.width, 2)} {calc.unit === UNITS.IMPERIAL ? 'ft' : 'm'}
                </p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Length</p>
                <p className="font-medium">
                  {formatNumber(calc.length, 2)} {calc.unit === UNITS.IMPERIAL ? 'ft' : 'm'}
                </p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Thickness</p>
                <p className="font-medium">
                  {formatNumber(calc.thickness, 2)} {calc.unit === UNITS.IMPERIAL ? 'in' : 'cm'}
                </p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Result</p>
                <p className="font-medium text-blue-700">
                  {formatNumber(calc.tonnage, 2)} {calc.unit === UNITS.IMPERIAL ? 'tons' : 'tonnes'}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};